var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoarea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 86,
    viewBox: "0 0 88 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8083 9.07078L32.6417 0.612448C30.6117 -0.112552 28.3883 -0.112552 26.3583 0.564115L7.07333 7.04078C3.15833 8.39411 0.5 12.0674 0.5 16.2241V73.4991C0.5 80.3141 7.315 84.9541 13.6467 82.4891L27.8083 76.9791C28.8717 76.5441 30.08 76.5441 31.1433 76.9308L55.31 85.3891C57.34 86.1141 59.5633 86.1141 61.5933 85.4374L80.8783 78.9608C84.7933 77.6558 87.4517 73.9341 87.4517 69.7775V12.5024C87.4517 5.68745 80.6367 1.04745 74.305 3.51245L60.1433 9.02245C59.08 9.40911 57.92 9.45745 56.8083 9.07078ZM58.5 76.3024L29.5 66.1041V9.69911L58.5 19.8974V76.3024Z",
    fill: "#E4E4E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoarea);
export default __webpack_public_path__ + "static/media/noarea.983f5e3767a28a3db22ae8825672b5f2.svg";
export { ForwardRef as ReactComponent };